module.exports = __webpack_public_path__ + "img/Sintomas Cancro Europeu na Colheita 7.b748d9e0.webp";